import { styled } from '@mui/material/styles';
import { visuallyHidden } from '@mui/utils';
import Classes from 'components/Classes';
import Container from 'components/Container';
import Schedule from 'components/schedule/Schedule';
import { ClassFilterProvider } from 'contexts/classFilterContext';
import useMixpanel from 'hooks/useMixpanel';
import React, { useEffect } from 'react';

const Home = () => {
  const track = useMixpanel();
  useEffect(() => {
    track('Screen View', {
      page_name: 'home',
    });
  }, [track]);

  return (
    <>
      <h1 style={visuallyHidden}>Exos - Schedule and Classes</h1>
      <main>
        <Schedule />
        <ClassFilterProvider>
          <ContainerStyled>
            <Classes />
          </ContainerStyled>
        </ClassFilterProvider>
      </main>
    </>
  );
};

export default Home;

const ContainerStyled = styled(Container)(({ theme }) => ({
  backgroundColor: theme.colors.gray['1'],
}));
